<template>
    <crud-delete
        :open="open"
        :loading="loading"
        :errorMessage="errorMessage"
        @delete="deletePlan"
        @close="$emit('close')"
    >
        <p>¿Eliminar el plan <strong>{{ plan.nombre }}</strong>?</p>
        <p class="caption grey--text">Esta acción no puede deshacerse. Los roles de empresa creados con este plan no serán eliminados.</p>
    </crud-delete>
</template>

<script>
import PlanProvider from '../../../providers/PlanProvider'
import { CrudDelete } from '@dracul/common-frontend'
import { ClientError } from '../../../../../errors'

export default {
    name: 'PlanDelete',
    components: { CrudDelete },
    props: {
        open: { type: Boolean, default: true },
        plan: { type: Object, required: true }
    },
    data() {
        return {
            errorMessage: '',
            loading: false
        }
    },
    methods: {
        deletePlan() {
            this.loading = true
            PlanProvider.deletePlan(this.plan.id)
                .then(() => {
                    this.$emit('planDeleted')
                    this.$emit('close')
                })
                .catch(error => {
                    let clientError = new ClientError(error)
                    this.errorMessage = clientError.i18nMessage
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>
